<script setup lang="ts">
//#region types
type ErrorPanelType = 'default' | 'no-data';

interface Props {
  type?: ErrorPanelType;
}
//#endregion

//#region define
withDefaults(defineProps<Props>(), {
  type: 'default',
});
//#endregion
</script>

<template>
  <div
    class="crm-error-panel"
    :class="{
      'crm-error-panel_type-default': type === 'default',
      'crm-error-panel_type-no-data': type === 'no-data',
    }"
  >
    <UiIcon
      name="info-circle"
      :size="12"
      color="inherit"
    />
    <slot />
  </div>
</template>

<style lang="scss">
  .crm-error-panel {
    display: inline-flex;
    padding: 7px 12px;
    border-radius: 8px;
    gap: 4px;

    &_type-default {
      font-size: 11px;
      line-height: 1.36;
      background-color: var(--palette-status-negative-subtle);
      color: var(--text-negative);
      align-items: baseline;
    }

    //&_type-no-data {
    //  font-size: 12px;
    //  line-height: normal;
    //  background-color: var(--crm-panel-bg);
    //  color: var(--crm-panel-stats);
    //  align-items: baseline;
    //}
  }
</style>
